import { render, staticRenderFns } from "./ProcessoDePagamento.vue?vue&type=template&id=5ff85f3e&scoped=true"
import script from "./ProcessoDePagamento.vue?vue&type=script&lang=js"
export * from "./ProcessoDePagamento.vue?vue&type=script&lang=js"
import style0 from "./ProcessoDePagamento.vue?vue&type=style&index=0&id=5ff85f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff85f3e",
  null
  
)

export default component.exports